__webpack_require__.p = "/docs/_next/";